import { loadListerReducer } from '../../lister/reducers/ListerReducer';
import listerSagas from '../../lister/sagas/ListerSagas';
const loadListerModule = (initialData) => ({
    id: 'Lister',
    reducerMap: {
        lister: loadListerReducer(initialData ? initialData.lister : null),
    },
    sagas: [listerSagas],
});
export default loadListerModule;
